import type { SVGProps } from "react";

const IcSendArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M20.9053 1.10449L18.7853 22.8948L12.7424 13.7419L15.3142 9.28797H17.0466L14.5053 13.6897L17.7027 18.5325L19.0925 4.24362L7.41326 12.5918L10.7253 12.7906L9.71539 14.2328L3.09424 13.8354L20.9053 1.10449Z" />
  </svg>
);

export default IcSendArrow;
